// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "productpg/" + {"189":"page-mixAndMatch","404":"page-singleProduct","406":"deferred"}[chunkId] + "." + {"189":"7119aae4657b051dc328","404":"60db485f549831ae8624","406":"48e5b251127370769642"}[chunkId] + ".css";
};